export function trackGoal(goal: String) {
    // @ts-ignore
    ym(65785078, 'reachGoal', goal);
}

export function setTrackingUserId(userId: string|undefined) {
    if (!userId) {
        return
    }
    // @ts-ignore
    ym(65785078, 'userParams', {
        UserID: userId,
    });
}